import axios from 'axios'
import React, {  Fragment } from 'react'
import Avatar from '@components/avatar'
import { toast, Slide } from 'react-toastify'
import { AlertCircle } from 'react-feather'
import config from '@src/configs/themeConfig'

const ErrorToastContent = ({ title, content }) => (
  <Fragment>
    <div className='toastify-header'>
      <div className='title-wrapper'>
        <Avatar size='sm' color='danger' icon={<AlertCircle size={12} />} />
        <h6 className='toast-title font-weight-bold'>{title}</h6>
      </div>
    </div>
    <div className='toastify-body'>
      <span>{content}</span>
    </div>
  </Fragment>
)

function upper(obj) {
  for (const prop in obj) {
  if (typeof obj[prop] === 'string') {
    obj[prop] = obj[prop].toUpperCase()
  }
  if (typeof obj[prop] === 'object') {
    upper(obj[prop])
    }
  }
  return obj
}

function cleanJson(data) {
  // if (typeof data === 'object') {
  //   const _data = {}
  //   Object.keys(data).forEach(key => {
  //     if (data[key] === '' || data[key] === undefined) {
  //       console.log('no entra')
  //     } else {
  //       _data[key] = data[key]
  //     }
  //   })
  //   return _data
  // } else {
    return data
  // }
}

// const accessToken = localStorage.getItem('accessToken')
const instance = axios.create({
  baseURL: config.app.baseUrl,
  transformRequest: [
    (data, headers) => {
      console.log(headers)
      // if (data) {
      //   data = upper(data)
      // }
      return data
    }, 
    ...axios.defaults.transformRequest
  ]
})

Tawk_API = Tawk_API || {}
Tawk_API.onLoad = function() {
  Tawk_API.setAttributes(JSON.parse((localStorage.getItem('rememberMe')==='true'?localStorage:sessionStorage).getItem('userData')), function(error) {
    console.log(error)
  })
  setInterval(() => {
    Tawk_API.setAttributes(JSON.parse((localStorage.getItem('rememberMe')==='true'?localStorage:sessionStorage).getItem('userData')), function(error) {
      console.log(error)
    })
  }, 5000)
}

instance.interceptors.request.use(function (config) {
  // Do something before request is sent
  const tester = new RegExp(/victimas|apoyos|asistenciaInmediata|audiencia|servicioInterno|fichaInformativa|erogacion|fuds|event/g)
  if (tester.test(config.url)) config.data = cleanJson(upper(config.data))
  if (config.data && config.data.case) config.data.case = config.data.case.toLowerCase()
  return config
}, function (error) {
  // Do something with request error
  return Promise.reject(error)
})


instance.defaults.headers.common['Authorization'] = `Bearer ${(localStorage.getItem('rememberMe')==='true'?localStorage:sessionStorage).getItem('accessToken')}`

// instance.interceptors.request.use(req => {
//   const userData = localStorage.getItem('userData')
//   // `req` is the Axios request config, so you can modify
//   // the `headers`.
//   if (req.method === 'post') {
//   }

//   return req
// })

instance.refresh = () => {
  instance.defaults.headers.common['Authorization'] = `Bearer ${(localStorage.getItem('rememberMe')==='true'?localStorage:sessionStorage).getItem('accessToken')}`
}

instance.interceptors.response.use((response) => {
  return response
}, (err, response) => {
  if (err.response.data.code === 401) {
    window.location.pathname = '/login'
  }
  toast.error(
    <ErrorToastContent title={'Error'} content={err.response.data.message} />,
    { transition: Slide, hideProgressBar: true, autoClose: 10000 }
  )
  return response
})

export default instance